var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCamDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2424_55696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 7.875V5.25C12.75 4.8375 12.4125 4.5 12 4.5H3C2.5875 4.5 2.25 4.8375 2.25 5.25V12.75C2.25 13.1625 2.5875 13.5 3 13.5H12C12.4125 13.5 12.75 13.1625 12.75 12.75V10.125L15.75 13.125V4.875L12.75 7.875Z",
    fill: "#DCE0E4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2424_55696"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamDashboard);
export default __webpack_public_path__ + "static/media/iconCamDashboard.2439f6c2502d0f29108c485930820676.svg";
export { ForwardRef as ReactComponent };